import React from 'react';
import './home.css'
import Hero from '../Assets/Hero image.jpg'
import Button from '../Componenents/comman/Button';
import Header from '../Componenents/layout/header';
import Home_card1 from '../Componenents/comman/Home_card1';
import Home_img1 from '../Assets/card1_img1.jpg'
import Home_img2 from '../Assets/card1_img2.jpg'
import Home_img3 from '../Assets/card1_img3.jpg'
import Home_img4 from '../Assets/card1_img4.jpg'
import Model3D from '../Assets/3d model/smart_home_interior_floor_plan.glb'
import Model3D2 from '../Assets/3d model/Smart_Home_Interior_Floor_Plan.usdz'
import Home_icon1 from '../Assets/sheild icon.svg'
import Home_icon2 from '../Assets/badge icon.svg'
import Home_icon3 from '../Assets/team icon.svg'
import Home_icon4 from '../Assets/analytcis icon.svg'
import Home_card2 from '../Componenents/comman/Home_card2';
import Footer from '../components/Footer';

const Home = () => {
    return ( 
        <>
<Header/>
<main>
  <section className="hero">
    <img src={Hero} alt="" className="hero_img" />
    <div className="hero_div1">
      <div className="hero_div2">
        <h1 className="hero_h1">Discover Exceptional<br/>Living in Egypt</h1>
      </div>
      <Button text="View Properties" />
    </div>
  </section>
  <section className='home_sec2'>
    <h1 className='hero_h1'>Our Services</h1>
    <div className='home_sec2_div1'>
        <Home_card1 title="01" subtitle="Property showcase"  img={Home_img1}/>
        <Home_card1 title="02" subtitle="Site planning"  img={Home_img2}/>
        <Home_card1 title="03" subtitle="Building design"  img={Home_img3}/>
        <Home_card1 title="04" subtitle="Space Planning"  img={Home_img4}/>
    </div>
  </section>
  <section className='home_sec3'>
    <div className='home_sec3_div1'>  
        <h1 className='home_sec3_text1'>Virtual Reality <br/> Property Tours</h1>
        <h4 className='home_sec3_text2'>Experience properties like never before with our cutting-edge VR tours. Walk through your future home from anywhere in the world.</h4>
        <Button text="Explore VR Tours"></Button>
    </div>
    <model-viewer className='home_sec3_3dmodel'  src={Model3D} ios-src={Model3D2} camera-controls tone-mapping="neutral" poster="poster.webp" shadow-intensity="1.12" exposure="0.67" shadow-softness="0.2" min-camera-orbit="-180deg 2deg 32.8m" min-field-of-view="30deg" camera-target="-7.03m 1.368m -2.058m" max-camera-orbit="180deg 2deg auto" camera-orbit="-90deg 2deg 32.8m" field-of-view="30deg">
</model-viewer>
  </section>
  <section className='home_sec4'>
    <h1 className='hero_h1'>Why choose us</h1>
    <div className='home_sec4_div1'>
    <Home_card2 img={Home_icon1} title="Trusted & Secure" subtitle="Verified properties with complete legal documentation and transparency."/>
    <Home_card2 img={Home_icon2} title="Premium Selection" subtitle="Curated portfolio of Egypt's most prestigious properties."/>
    <Home_card2 img={Home_icon3} title="Expert Team" subtitle="Professional advisors with deep local market knowledge."/>
    <Home_card2 img={Home_icon4} title="Investment Value" subtitle="High-growth locations with excellent ROI potential."/>
    </div>
  </section>
</main>
<Footer/>
        </>
     );
}
 
export default Home;